import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import PropTypes from "prop-types"
import React from "react"
import "./logo-bar-v2.scss"

const LogoBarV2 = ({ ctaButton, heading, logos }) => {
  return (
    <section className="logo-bar-v2">
      <div className="container-v2">
        {heading && <h2>{heading}</h2>}
        <div className="logo-bar-v2--logo-wrapper">
          {logos.map(logo => (
            <Image
              alt={logo.title}
              className="logo-bar-v2--logo"
              image={logo.fluid}
              key={logo.id}
            />
          ))}
        </div>
        {ctaButton && (
          <p>
            <ButtonV2
              accessibilityLabel={ctaButton.accessibilityLabel}
              className={getButtonClasses(
                ctaButton.buttonStyle || "primary-green",
                ctaButton.buttonSize || "large"
              )}
              href={ctaButton.path}
              key={ctaButton.id}
              showArrow={ctaButton.showArrow === "Yes" ? true : false}
              text={ctaButton.text}
            />
          </p>
        )}
      </div>
    </section>
  )
}

LogoBarV2.propTypes = {
  ctaButton: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  logos: PropTypes.array.isRequired,
}

export default LogoBarV2
